import { ApolloError, gql, useMutation } from "@apollo/client";

import { errorNotification } from "../../../common/variables/notification";
import {
  AddServiceInput,
  BatchAddServicesMutation,
  BatchAddServicesMutationVariables,
} from "../../../API";
import { BATCH_ADD_SERVICES } from "../../../common/operations/mutations";

export const useCreateBatchServices = () => {
  const [saveBatchCreateServices, { data, loading }] = useMutation<
    BatchAddServicesMutation,
    BatchAddServicesMutationVariables
  >(BATCH_ADD_SERVICES);

  const batchCreateServices = async (input: AddServiceInput[]) => {
    return await saveBatchCreateServices({
      variables: {
        input,
      },
      awaitRefetchQueries: true,
      onError: (error: ApolloError): void => {
        errorNotification(error.message);

        console.error(error.message);
      },
      update: async (cache, response) => {
        cache.modify({
          fields: {
            getServices(existing) {
              const newServicesRefs =
                response?.data?.batchAddServices?.map(s => {
                  return cache.writeFragment({
                    data: s,
                    fragment: gql`
                      fragment NewService on Service {
                        customerId
                        deviceId
                        healthData
                        id
                        isRunning
                        locationId
                        nodeId
                        serviceType
                        configuration
                      }
                    `,
                  });
                }) ?? [];

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [...existing.items, ...newServicesRefs],
              };
            },
          },
        });
      },
      refetchQueries: [
        "GetServices",
        "GetServicesByLocation",
        "GetZonesByDevice",
      ],
    });
  };

  return {
    batchCreateServices,
    data,
    loading,
  };
};
